function createItemList ( id, name ) {
    return Object.freeze( {id, name} );
}

export const CommerceItemLists = Object.freeze( {
    SEARCH_RESULTS: createItemList( 'search_results', 'Search Results' ),
    SUGGESTED_PRODUCTS: createItemList( 'suggested_products', 'Suggested Products' ),
    REORDER: createItemList( 'reorder', 'Reorder' ),
    RECENTLY_VIEWED: createItemList( 'recently_viewed', 'Recently Viewed' ),
    CATEGORY: createItemList( 'category', 'Category Page' ),
    RELATED_PRODUCTS: createItemList( 'related_products', 'Related Products' ),
    FEATURED: createItemList( 'featured', 'Featured Products' ),
    SAVED_LIST: createItemList( 'saved_list', 'Saved List' ),
    PRODUCT_DETAILS: createItemList( 'product_details_products', 'Product Details' ),
    FORMULARY_PRODUCTS: createItemList( 'formulary_products', 'Formulary Products' ),
    DIRECT_CART_ADD: createItemList( 'direct_cart_add', 'Direct Cart Add' )
} );

export const SearchTypes = Object.freeze( {
    HEADER: 'header',
    MOBILE: 'mobile',
    RESULTS_REFINEMENT: 'results_refinement',
    SUGGESTION: 'suggestion'
} );

export const SuggestionTypes = Object.freeze( {
    QUERY: 'query',
    CATEGORY: 'category',
    CONTENT: 'content'
} );

export function isCanonicalItemList ( itemList ) {
    if ( !itemList ) {
        return false;
    }

    return Object.values( CommerceItemLists ).some( canonicalList =>
        canonicalList.id === itemList.id && canonicalList.name === itemList.name
    );
}

export function getCanonicalItemListByName ( name ) {
    return Object.values( CommerceItemLists ).find( itemList => itemList.name === name ) || null;
}

export function getCanonicalItemList ( id, name ) {
    return Object.values( CommerceItemLists ).find( itemList =>
        itemList.id === id && itemList.name === name
    ) || null;
}

export function isSearchType ( searchType ) {
    return Object.values( SearchTypes ).includes( searchType );
}

export function isSuggestionType ( suggestionType ) {
    return Object.values( SuggestionTypes ).includes( suggestionType );
}
